import React from "react";
import {
    Box,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import {TemplateItemModel} from "../../models/TemplateModel";

interface TemplateDetailsProps {
    template: {
        id: string;
        name: string;
        description: string;
        items: TemplateItemModel[];
    };
}

const TemplateDetails: React.FC<TemplateDetailsProps> = ({template}) => {
    return (
        <Box sx={{mt: '24px'}}>
            <Stack spacing={'16px'}>
                <Box>
                    <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
                        Naam:
                    </Typography>
                    <Typography>{template.name}</Typography>
                </Box>
                <Box>
                    <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
                        Beschrijving:
                    </Typography>
                    <Typography color="textSecondary">
                        {template.description || "Geen beschrijving beschikbaar"}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="subtitle1" sx={{fontWeight: "bold", mb: '16px'}}>
                        Items:
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Naam</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Beschrijving</TableCell>
                                    <TableCell>Voorbeelden</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {template.items.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.type}</TableCell>
                                        <TableCell>{item.description || "Geen beschrijving"}</TableCell>
                                        <TableCell>{item.examples || "Geen voorbeelden"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Stack>
        </Box>
    );
};

export default TemplateDetails;
